import api from '~/services/api';
import PropTypes from 'prop-types';

const endPoint = 'extraexpenses';

// GET
export const getExtraExpenses = async (params) => {
  try {
    const { data } = await api.get(`/${endPoint}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createExtraExpenses = async (values) => {
  try {
    const { data } = await api.post(`/${endPoint}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateExtraExpenses = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteExtraExpenses = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    return data.data;
  } catch (error) {
    throw error;
  }
};

getExtraExpenses.propTypes = {
  params: PropTypes.object.isRequired,
};

createExtraExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

updateExtraExpenses.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteExtraExpenses.propTypes = {
  id: PropTypes.string.isRequired,
};
